
import React, { useEffect, useState } from "react";
import {languages} from "../components/utility";



const fetchData = async function(data) {
    const response = await fetch("https://api-fetch.mediadirhub.com/ai-builder", {
        method:"POST",
        body:JSON.stringify(data)
    });
    return await response.json();
}

const keys = ["socialnetworkrevamp", "store", "messenger", "dating", "quiz", "demanddelivery", "foodcourt", "map", "appsheet", "audio", "taxi", "loyalitycard", "religious", "ewallet", "database", "ereader", "news", "video","event","donation", "aboutus", "dictionary", "stock", "auction", "videoconference", "directory", "roomreservation" ,"recipe", "photo", "forum", "fitness", "googledrive", "hippaforms", "document", "pockettools", "flashcard", "formbuilder", "to-do-list", "real-estate", "hyperlocal", "appointment", "googleclassroom", "pedometer", "soundrecorder", "groceryorderform", "qrcode", "blog", "contactfeature", "religiousgeeta", "religiousquran"];
const languagekeys = ['en', 'fr', 'pt', 'sa', 'es', 'de', 'it', 'jp', 'ru', 'nl', 'cn']
const initialData = {};

keys.forEach(function(v){
  initialData[v] = [];
});


const FeatureTable = () => {
  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(true);
  const [editState, setEditState] = useState({}); // { lang: id }
  const [formState, setFormState] = useState({}); // { lang: { feature, webUrl, appUrl } }

  const startEdit = (lang, row) => {
    if (editState[lang]) return;
    setEditState(prev => ({ ...prev, [lang]: row.id }));
    setFormState(prev => ({ ...prev, [lang]: { feature: row.feature, webUrl: row.webUrl, appUrl: row.appUrl } }));
  };

  const saveEdit = (lang, id) => {
    const updated = data[lang].map(row =>
      row.id === id ? { ...row, ...formState[lang] } : row
    );
    setData(prev => ({ ...prev, [lang]: updated }));
    setEditState(prev => ({ ...prev, [lang]: null }));
  };

  const addNewRow = function(key) {
    const nextData = JSON.parse(JSON.stringify(data));
    nextData[key].push({"url":"", "type":"app", "lang":"en"});
    setData(nextData);
  }

  const updateRow = function(key, index, id, value) {
    const nextData = JSON.parse(JSON.stringify(data));
    nextData[key][index][id] = value;
    setData(nextData);
  }

  useEffect(() => {
    //setLoading(false)
    fetchData({
      "method":"getSimulatorFeatures"
    }).then(function(response){
      if(response.data !== {}) {
        const liveData = {};
        keys.forEach(function(key){
          if(response.data[key]) {
            liveData[key] = response.data[key];
          }
          else {
            liveData[key] = [];
          }
        })
        setData(liveData);
        setLoading(false);
      }
      else {
        setLoading(false);
      }
    });
  }, []);

  useEffect(() => {
    if(!loading) {
      fetchData({
        "method":"getSimulatorFeatures",
        "data":data
      }).then(function(response){
        console.log(response)
      })
    }
    
  }, [data]);

  return (
    <div className="container py-4" style={{overflowY: "scroll",height: "100%"}}>
      {
      Object.keys(data).map(function(key){
        return <>
         <div className="w-100 text-capitalize h2">{key}</div>
         <table className="table table-bordered features-table">
         <thead>
    <tr>
      <th scope="col" className="w-60">URL</th>
      <th scope="col" className="w-10">Type</th>
      <th scope="col" className="w-30">Language</th>
    </tr>
   
  </thead>
  <tbody>
    {
      data[key].map(function(item, index){
        return <tr>
        <th scope="row">          <input type="url" className="form-control" id="linkInput" placeholder="Enter link" defaultValue={item.url} onBlur={function(event){
          updateRow(key, index, "url", event.currentTarget.value.trim())
        }} />
  </th>
        <td>
        <div className="btn-group w-100 btn-group-sm">
          {
            ["app", "web"].map(function(v){
              let activeClass = "";
              if(item.type === v) {
                activeClass = "active";
              }
            return <button type="button" className={`btn btn-outline-secondary text-uppercase ${activeClass}`} onClick={() => updateRow(key, index, "type", v)}>{v}</button>
            })
          }
    
  </div>
        </td>
        <td>
        <div className="btn-group btn-group-sm w-100">
          {
            languagekeys.map(function(v){
              let activeClass = "";
              if(item.lang === v) {
                activeClass = "active";
              }
              return <button type="button" className={`btn btn-outline-secondary text-uppercase ${activeClass}`} onClick={() => updateRow(key, index, "lang", v)}>{v}</button> 
            })
          }
    
  </div>
        </td>
      </tr>
      })
    }
    </tbody>

         </table>
         <div className="w-100 text-end"><button type="button" className="btn btn-primary btn-lg" onClick={() => addNewRow(key)}>Add Link</button>
</div>
        
        </>
         
      })
      }
    </div>
  );
};

export default FeatureTable;


